//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Error-1",
  mounted: function mounted() {},
  computed: {
    backgroundImage: function backgroundImage() {
      return process.env.BASE_URL + "media/error/bg1.jpg";
    }
  }
};